import { Component, Input, OnInit } from '@angular/core';
import { parse } from 'querystring';
import { AdminService, AuthService, CalendarService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
    selector: 'sn-usc-metrics-bar',
    templateUrl: './usc-metrics-bar.component.html',
    styleUrls: ['./usc-metrics-bar.component.css']
})
export class UscMetricsBarComponent implements OnInit {
    @Input() sales_metric: any;
    // @Input() action_plan: any;
    // @Input() daily_goal: any;
    // @Input() todays_goal: any;
    // @Input() mtd: string;
    // @Input() dtd: string;
    // @Input() quota: string;
    // @Input() area_quota: string;
    // @Input() territory_quota: string;
    // @Input() region_quota: string;
    // @Input() p2w_goal: string;
    @Input() mode: string;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() placement: any;
    // @Input() result_type: any;
    @Input() sales_mode: any;
    // @Input() achievement_ID: number;
    @Input() scope_month: string;

    isMonthlySales: boolean = false;
    isDailySales: boolean = false;
    isWeightedScorecard: boolean = false;
    isSalesVsQuota: boolean = false;
    isSalesVsGoal: boolean = false;
    isSalesMetricEnabled: boolean = false;
    isOtherResults: boolean = false;
    isActionPlanSubmitted: boolean = false;
    isActivePlanApproved: boolean = false;
    isAppointmentsAssigned: boolean = false;
    isAppointmentsByType: boolean = false;
    isActiveLeadContacted: boolean = false;
    isAssociatesWorkingToday: boolean = false;
    isLeadsContacted: boolean = false;
    isLeadsContactedLeaderboard: boolean = false;
    isScheduledAppts: boolean = false;
    isDashboardWidget: boolean = false;
    isScheduledApptsLeaderboard: boolean = false;
    isDashboardLeaderboard: boolean = false;
    // isCustomAchievement: boolean = false;
    // scope_achievement:any;
    days_in_month: number = 31;
    other_results_stats:any = { approved: 0, requested: 0, draft: 0, total: 0 }
    bar_segment_configs: Array<any> = [];
    public is_current_month: boolean = true;
    public current_user: any = null;

    //other result constants
    segment_gray:string = "#e4e4e4";
    segment_other:string = "#7e7e7e";
    segment_green:string = "#2ebb05";
    segment_red:string = "#b91348";
    segment_blue:string = "#004392";
    segment_yellow:string = "#f7a600";

    public team_sales_quota_achievements:any = null;

    constructor(
        public uscStoreService: UscStoreService,
        public translatorService: TranslatorService,
        public calendarService: CalendarService,
        public authService: AuthService,
        public adminService: AdminService,
    ) {
        var today = new Date();
        this.days_in_month = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
        this.current_user = this.authService.getActive();
    }

    ngOnInit() {
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        // this.isCustomAchievement = this.achievement_ID > 0;
        this.isMonthlySales = (this.mode == "monthly");
        this.isDailySales = (this.mode == "daily");
        // this.isWeightedScorecard = (this.mode == "scorecard");
        this.isActivePlanApproved = (this.sales_mode == "action_plans_approved");
        this.isAppointmentsAssigned = (this.sales_mode == "appointments_assigned");
        this.isAppointmentsByType = (this.sales_mode == "appointments_by_type");
        this.isActiveLeadContacted = (this.sales_mode == "active_leads_contacted");
        this.isAssociatesWorkingToday = (this.sales_mode == "associates_working_today");
        this.isLeadsContacted = (this.sales_mode == "leads_contacted");
        this.isScheduledAppts = (this.sales_mode == "scheduled_appointments");
        this.isLeadsContactedLeaderboard = (this.sales_mode == "leads_contacted_leaderboard");
        this.isScheduledApptsLeaderboard = (this.sales_mode == "scheduled_appointments_leaderboard");
        this.isDashboardWidget = this.isLeadsContacted || this.isScheduledAppts;
        this.isDashboardLeaderboard = this.isLeadsContactedLeaderboard || this.isScheduledApptsLeaderboard;
        this.isOtherResults = this.isActivePlanApproved || this.isAppointmentsAssigned || this.isAppointmentsByType || this.isActiveLeadContacted || this.isAssociatesWorkingToday;
        if (!this.isOtherResults) {
            if (this.sales_metric) this.isSalesVsGoal = this.sales_metric.dataset_type.indexOf('sales_vs_goal') >= 0 && !this.isDashboardWidget && !this.isDashboardLeaderboard; 
            if (this.sales_metric) this.isSalesVsQuota  = this.sales_metric.dataset_type.indexOf('sales_vs_quota') >= 0 && !this.isDashboardWidget && !this.isDashboardLeaderboard;
            if (this.sales_metric) this.isSalesMetricEnabled = this.sales_metric.metric_enabled == 'Yes' && (this.isSalesVsGoal || this.isSalesVsQuota);
        }

        this.updateOtherResults(true);

        // Listener: updates when user changes the available month selection
        this.uscStoreService.p2wScopeMonth.subscribe(m => {
            if (m.length == 6 && this.scope_month != m) {
                this.scope_month = m;
                this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
                this.updateOtherResults(true);
            }
        })        
    }

    getModeClass():string {
        // if (this.isCustomAchievement) return "row no-gutters";
        if (this.isActivePlanApproved) return "row no-gutters other_results " + this.mode;
        if (this.isAppointmentsAssigned) return "row no-gutters other_results " + this.mode;
        if (this.isAppointmentsByType) return "row no-gutters other_results " + this.mode;
        if (this.isActiveLeadContacted) return "row no-gutters other_results " + this.mode;
        if (this.isAssociatesWorkingToday) return "row no-gutters other_results " + this.mode;
        return "row no-gutters " + this.mode;
    }

     getBarLabel():string {
        // if (this.isCustomAchievement) return "";
        if (this.isActivePlanApproved) return "Action Plans Approved";
        if (this.isAppointmentsAssigned) return "Appointments Assigned";
        if (this.isAppointmentsByType) return "Appointments By Type";
        if (this.isActiveLeadContacted) return "Active Leads Contacted";
        if (this.isAssociatesWorkingToday) return "Associates Working Today";
        if (this.isLeadsContacted) return this.sales_metric.label;
        if (this.isLeadsContactedLeaderboard) return this.sales_metric.label;
        if (this.sales_metric) return this.sales_metric.label;
        // if (this.isMonthlySales) return this.uscStoreService.getBusinessDriver(this.mtd);
        // if (this.isDailySales) return this.uscStoreService.getBusinessDriver(this.dtd);
        // if (this.isWeightedScorecard && this.placement) return this.getPlacementLabel();
        return "";
    }

    getSubLabel(): string {
        if (this.isLeadsContactedLeaderboard || this.isDashboardLeaderboard) return this.sales_metric.sub_label;
        if (this.sales_metric) return this.sales_metric.sub_label;
    }

    getBarPercentageText():string {
        return this.getBarPercentage() != null ? this.translatorService.toPercentage(this.getBarPercentage()) : "";
    }

    getBarSubLabel():string {
        return "bar sub label";
        // if (this.isWeightedScorecard && this.placement) {
        //     var associate = this.adminService.getUserByUsername(this.placement.achievement.CREATOR_ID);
        //     if (associate) {
        //         var label = this.uscStoreService.getItemCustomFieldValue(associate, 'Pinnacle Club Winner');
        //         if (label) return " - " + label;
        //     }
        // }
        // return "";
    }

    getBarSubLabelStyle() {
        let style:any = { display: "none" };
        if (this.isWeightedScorecard && this.placement && this.getBarSubLabel()) {
            style = { "color": "#0731A1" };
        }
        return style;
    }
    
    getBarPercentage():number {
        var pct = 0;
        if (this.sales_metric) {
            if (this.isSalesVsGoal) pct = this.sales_metric.goal_pct;
            if (this.isSalesVsQuota) pct = this.sales_metric.quota_pct;
            if (this.isLeadsContacted) pct = this.sales_metric.value_pct;
            if (this.isScheduledAppts) pct = this.sales_metric.value_pct;
            if (this.isLeadsContactedLeaderboard) pct = this.sales_metric.value;
            if (this.isScheduledApptsLeaderboard) pct = this.sales_metric.value;
            return (pct > 0.99 && pct < 1) ? 0.99 : pct;
        }
        // if (this.isCustomAchievement) return 0;
        if (this.isActivePlanApproved) return this.other_results_stats.approved_pct;
        if (this.isAppointmentsAssigned) return this.other_results_stats.assigned_pct;
        if (this.isAppointmentsByType) return null;
        if (this.isActiveLeadContacted) return this.other_results_stats.leads_contacted_pct;
        if (this.isAssociatesWorkingToday) return this.other_results_stats.associates_working_pct;
        // if (this.isMonthlySales) return this.getMtdPercentage();
        // if (this.isDailySales) return this.getDtdPercentage();
        // if (this.isWeightedScorecard) return this.getPlacementPercentage();
        return 0;
    }

    getEstimatedBarPercentage():number {
        var pct = 0;
        if (this.sales_metric) {
            if (this.isSalesVsGoal) pct = this.sales_metric.estimated_goal_pct;
            if (this.isSalesVsQuota) pct = this.sales_metric.estimated_quota_pct;
            return (pct > 0.99 && pct < 1) ? 0.99 : pct;
        }
    }

    getSalesMetricValue(): any {
        if (this.sales_metric) {
            var is_currency = this.sales_metric.label.toLowerCase().indexOf("revenue") >= 0;
            return (is_currency) ? this.translatorService.toCurrency(this.sales_metric.value) : this.sales_metric.value;
        }
        return 0;
    }

    getBarStyle() {
        if (this.isWeightedScorecard) {
            return { "background-color": "#c0cfe1" };
        } else if (this.isDashboardWidget) {
            var bg_color = this.uscStoreService.getFillBgColor(this.getBarPercentage());
            return { "background-color": bg_color };
        } else if (this.isDashboardLeaderboard) {
            var bg_color = this.uscStoreService.getFillBgColor(this.getBarPercentage());
            return { "background-color": bg_color };
        } else {
            var bg_color = this.isSalesMetricEnabled ? this.uscStoreService.getFillBgColor(this.getBarPercentage()) : "#f2f2f2";
            return { "background-color": bg_color };
        }
    }

    getFillStyle() {
        var pct = this.getBarPercentage();
        if (this.isDashboardWidget) {
            var bg_color = this.uscStoreService.getFillColor(pct);
        } else if (this.isDashboardLeaderboard) {
            var bg_color = this.uscStoreService.getFillColor(pct);
        } else {
            if (!this.isSalesMetricEnabled) pct = this.getEstimatedBarPercentage();
            var bg_color = (this.isWeightedScorecard && this.placement) ? "#004897" : this.uscStoreService.getFillColor(pct);
            if (!this.isSalesMetricEnabled) bg_color = "#e4e4e4";
        }
        return { width: this.translatorService.toPercentage(pct >= 1 ? 1 : pct), "background-color": bg_color };
    }

    getSlitStyle() {
        var pct = this.getWorkedScheduledPercentage();
        var bg_color = this.isSalesMetricEnabled ? 'red' : '#9f9f9f';
        return { left: this.translatorService.toPercentage(pct >= 1 ? 1 : pct), "background-color": bg_color };
    }

    getWorkedScheduledPercentage() {
        if (this.isSalesVsGoal || this.isSalesVsQuota) {
            return (new Date()).getDate() / this.days_in_month;
        } 
        // else if (this.action_plan) {
        //     return this.action_plan.days_worked / this.action_plan.cs_days_scheduled;
        // }
        return 0;
    }
    getFormattedMtd() {
        var mtd = 0;
        var is_currency = false, is_percentage = false, is_agent_metrics = false;
        if (this.sales_metric) {
            if (this.isSalesVsGoal || this.isSalesVsQuota) {
                mtd = this.sales_metric.value;
                is_currency = this.sales_metric.label.toLowerCase().indexOf("revenue") >= 0;
                is_percentage = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
                is_agent_metrics = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
            }
        }
        if (is_currency) return this.translatorService.toCurrency(mtd);
        if (is_percentage) return this.translatorService.toPercentage(is_agent_metrics ? mtd / 100 : mtd);
        return mtd.toFixed(0);
    }
    
    getFormattedQuota() {
        var quota = 0;
        var is_currency = false, is_percentage = false, is_agent_metrics = false;
        if (this.sales_metric) {
            if (this.isSalesVsQuota) {
                quota = this.sales_metric.quota;
                is_currency = this.sales_metric.label.toLowerCase().indexOf("revenue") >= 0;
                is_percentage = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
                is_agent_metrics = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
            }
        }
        if (is_currency) return this.translatorService.toCurrency(Math.ceil(quota));
        if (is_percentage) return this.translatorService.toPercentage(is_agent_metrics ? Math.ceil(quota) / 100 : Math.ceil(quota));
        return Math.ceil(quota).toFixed(0);
    }

    getFormattedGoal() {
        var goal = 0;
        var is_currency = false, is_percentage = false, is_agent_metrics = false;
        if (this.sales_metric) {
            if (this.isSalesVsGoal) {
                goal = this.sales_metric.goal;
                is_currency = this.sales_metric.label.toLowerCase().indexOf("revenue") >= 0;
                is_percentage = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
                is_agent_metrics = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
            }
        }
        if (is_currency) return this.translatorService.toCurrency(Math.ceil(goal));
        if (is_percentage) return this.translatorService.toPercentage(is_agent_metrics ? Math.ceil(goal) / 100 : Math.ceil(goal));
        return Math.ceil(goal).toFixed(0);
    }
    
    isGoalAchieved():boolean { 
        if (this.isSalesMetricEnabled) {
            // if (this.isCustomAchievement) return false;
            if (this.isDailySales) return this.getBarPercentage() >= 1; 
            if (this.isMonthlySales) return this.getBarPercentage() >= 1; 
        }
        return false;
    }

    isSlitVisible() {
        var is_agent_metrics = this.sales_metric.metric_key.indexOf('dp_attach_rate') >= 0 || this.sales_metric.metric_key.indexOf('plan_mix') >= 0;
        return (this.is_current_month && !is_agent_metrics);
    }
    
    getFillContainerStyle(seg) {
        return {"z-index": seg.zindex }
    }
    getSegmentFillStyle(seg) {
        return { width: this.translatorService.toPercentage(seg.fill_pct >= 1 ? 1 : seg.fill_pct), "background-color": seg.fill_color, "z-index": seg.zindex };
    }

    getSegPanelClass() {
        if (this.isAppointmentsByType) return "abt";
        if (this.isActiveLeadContacted) return "alc";
        if (this.isAssociatesWorkingToday) return "awt";
        return "tip"; 
    }
    getSegmentIconClass(seg) { return seg.legend_icon; }
    getSegmentDesc(seg) { return seg.desc; }
    
    private updateOtherResults(bReloadOtherResults:boolean) {
        if (this.isActivePlanApproved || this.isAppointmentsAssigned || this.isAppointmentsByType || this.isActiveLeadContacted || this.isAssociatesWorkingToday) {
            this.getCalculatedOtherResults(this.isDailySales, this.scope_type, this.scope_value, this.scope_month, bReloadOtherResults);
        }
    }

    public getCalculatedOtherResults(bTodayOnly:boolean = false, scope_type:string, scope_value:string, scope_month:string, bReload:boolean = false) {
        if (bTodayOnly) {
            this.uscStoreService.getP2WTodaysOtherResults(this.sales_mode, scope_type, scope_value, scope_month, bReload).subscribe(result => { 
                this.other_results_stats = this.getOtherResultStats(result, bTodayOnly);
                this.bar_segment_configs = this.getOtherResultsInSegments(this.other_results_stats);
             })
        } else {
            this.uscStoreService.getP2WOtherResults(this.sales_mode, scope_type, scope_value, scope_month, bReload).subscribe(result => { 
                this.other_results_stats = this.getOtherResultStats(result, bTodayOnly);
                this.bar_segment_configs = this.getOtherResultsInSegments(this.other_results_stats);
             })
        }
    }
    
    getOtherResultsInSegments(other_results_stats) {
        var bar_segment_configs = [];
        var desc_template = "_COUNT_ (_PCT_) _LABEL_";
        var seg_desc = "";
        var segment_color = null;
        if (this.isActivePlanApproved) {
            if (other_results_stats.action_plans_total = 0) segment_color =  this.segment_gray;
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.action_plans_approved).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.approved_pct)).replace('_LABEL_', 'Approved');
            bar_segment_configs.push({ fill_pct: other_results_stats.approved_pct, fill_color:  this.segment_green, zindex: 4, legend_icon: "fa fa-square fa-1 iapproved", desc: seg_desc })
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.action_plans_requested).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.requested_pct)).replace('_LABEL_', 'Requested');
            bar_segment_configs.push({ fill_pct: other_results_stats.requested_pct + other_results_stats.approved_pct, fill_color: this.segment_blue, zindex: 3, legend_icon: "fa fa-square fa-1 irequested", desc: seg_desc })
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.action_plans_in_draft).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.draft_pct)).replace('_LABEL_', 'Draft');
            bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 idraft", desc: seg_desc })
        } else if (this.isAppointmentsAssigned) {
            if (other_results_stats.appt_total = 0) segment_color =  this.segment_gray;
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.appt_assigned).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.assigned_pct)).replace('_LABEL_', 'Assigned');
            bar_segment_configs.push({ fill_pct: other_results_stats.assigned_pct, fill_color: this.segment_green, zindex: 4, legend_icon: "fa fa-square fa-1 iassigned", desc: seg_desc })
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.appt_unassigned).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.unassigned_pct)).replace('_LABEL_', 'Unassigned');
            bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 iunassigned", desc: seg_desc })
        } else if (this.isAppointmentsByType) {
            if (other_results_stats.abt_appt_total = 0) segment_color =  this.segment_gray;
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.accessory_purchase).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.accessory_purchase_pct)).replace('_LABEL_', 'Accessory Purchase');
            bar_segment_configs.push({ fill_pct: other_results_stats.accessory_purchase_pct, fill_color: this.segment_green, zindex: 5, legend_icon: "fa fa-square fa-1 iap", desc: seg_desc });
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.device_upgrade).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.device_upgrade_pct)).replace('_LABEL_', 'Device Upgrade');
            bar_segment_configs.push({ fill_pct: other_results_stats.device_upgrade_pct + other_results_stats.accessory_purchase_pct, fill_color: this.segment_blue, zindex: 4, legend_icon: "fa fa-square fa-1 idu", desc: seg_desc });
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.new_service).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.new_service_pct)).replace('_LABEL_', 'New Service');
            bar_segment_configs.push({ fill_pct: other_results_stats.new_service_pct + other_results_stats.device_upgrade_pct + other_results_stats.accessory_purchase_pct, fill_color: this.segment_yellow, zindex: 3, legend_icon: "fa fa-square fa-1 ins", desc: seg_desc });
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.urgent_device_ts).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.urgent_device_ts_pct)).replace('_LABEL_', 'Urgent Device Troubleshooting');
            bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 iudts", desc: seg_desc });
            //bar_segment_configs.push({ fill_pct: other_results_stats.urgent_device_ts_pct + other_results_stats.new_service_pct + other_results_stats.device_upgrade_pct + other_results_stats.accessory_purchase_pct, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 iudts", desc: seg_desc });
            // seg_desc = desc_template.replace('_COUNT_', other_results_stats.other).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.other_ts_pct)).replace('_LABEL_', 'Other');
            // bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_other, zindex: 1, legend_icon: "fa fa-square fa-1 iother", desc: seg_desc });
        } else if (this.isActiveLeadContacted) {
            if (other_results_stats.leads_total = 0) segment_color =  this.segment_gray;
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.leads_contacted).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.leads_contacted_pct)).replace('_LABEL_', 'Leads Contacted');
            bar_segment_configs.push({ fill_pct: other_results_stats.leads_contacted_pct, fill_color: this.segment_green, zindex: 4, legend_icon: "fa fa-square fa-1 icontacted", desc: seg_desc });
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.leads_not_contacted).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.leads_not_contacted_pct)).replace('_LABEL_', 'Leads Not Contacted');
            bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 inotcontacted", desc: seg_desc });
        } else if (this.isAssociatesWorkingToday) {
            if (other_results_stats.associates_total = 0) segment_color =  this.segment_gray;
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.associates_working).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.associates_working_pct)).replace('_LABEL_', 'Associates Working');
            bar_segment_configs.push({ fill_pct: other_results_stats.associates_working_pct, fill_color: this.segment_green, zindex: 4, legend_icon: "fa fa-square fa-1 icontacted", desc: seg_desc });
            seg_desc = desc_template.replace('_COUNT_', other_results_stats.associates_not_working).replace('_PCT_', this.translatorService.toPercentage(other_results_stats.associates_not_working_pct)).replace('_LABEL_', 'Associates Not Working');
            bar_segment_configs.push({ fill_pct: 1, fill_color: other_results_stats.empty_segment || this.segment_red, zindex: 2, legend_icon: "fa fa-square fa-1 inotcontacted", desc: seg_desc });
        }
        return bar_segment_configs;
    }

    public getOtherResultStats(other_results:any, bTodayOnly:boolean) {
        let other_results_stats:any = {};
        if (this.isActivePlanApproved) {
            // action_plans_approved
            other_results_stats.action_plans_approved = other_results.find(r => r.result_name == 'action_plans_approved' && r.result_label == 'action_plans_approved').result_count;
            other_results_stats.action_plans_requested = other_results.find(r => r.result_name == 'action_plans_approved' && r.result_label == 'action_plans_requested').result_count;
            other_results_stats.action_plans_in_draft = other_results.find(r => r.result_name == 'action_plans_approved' && r.result_label == 'action_plans_in_draft').result_count;
            other_results_stats.action_plans_total = other_results.find(r => r.result_name == 'action_plans_approved' && r.result_label == 'action_plans_total').result_count;
            other_results_stats.approved_pct = other_results_stats.action_plans_approved / other_results_stats.action_plans_total;
            other_results_stats.requested_pct = other_results_stats.action_plans_requested / other_results_stats.action_plans_total;
            other_results_stats.draft_pct = other_results_stats.action_plans_in_draft / other_results_stats.action_plans_total;
            if (other_results_stats.action_plans_total == 0) {
                other_results_stats.approved_pct = other_results_stats.requested_pct = other_results_stats.draft_pct = 0;
                other_results_stats.empty_segment = this.segment_gray;
            }
        } else if (this.isAppointmentsAssigned) {
            // appointments_assigned
            other_results_stats.appt_total = other_results.find(r => r.result_name == 'appointments_assigned' && r.result_label == 'appointment_total').result_count;
            other_results_stats.appt_assigned = other_results.find(r => r.result_name == 'appointments_assigned' && r.result_label == 'appointment_assigned').result_count;
            other_results_stats.appt_unassigned = other_results.find(r => r.result_name == 'appointments_assigned' && r.result_label == 'appointment_unassigned').result_count;
            other_results_stats.assigned_pct = other_results_stats.appt_assigned / other_results_stats.appt_total;
            other_results_stats.unassigned_pct = other_results_stats.appt_unassigned / other_results_stats.appt_total;
            if (other_results_stats.appt_total == 0) {
                other_results_stats.assigned_pct = other_results_stats.unassigned_pct = 0;
                other_results_stats.empty_segment = this.segment_gray;
            }
        } else if (this.isAppointmentsByType) {
            // appointments_by_type
            other_results_stats.accessory_purchase = other_results.find(r => r.result_name == 'appointments_by_type' && r.result_label == 'Accessory Purchase');
            other_results_stats.device_upgrade = other_results.find(r => r.result_name == 'appointments_by_type' && r.result_label == 'Device Upgrade');
            other_results_stats.new_service = other_results.find(r => r.result_name == 'appointments_by_type' && r.result_label == 'New Service');
            other_results_stats.urgent_device_ts = other_results.find(r => r.result_name == 'appointments_by_type' && r.result_label == 'Urgent Device Troubleshooting');
            other_results_stats.other = other_results.find(r => r.result_name == 'appointments_by_type' && r.result_label == 'Other');

            other_results_stats.accessory_purchase = other_results_stats.accessory_purchase ? other_results_stats.accessory_purchase.result_count : 0;
            other_results_stats.device_upgrade = other_results_stats.device_upgrade ? other_results_stats.device_upgrade.result_count : 0;
            other_results_stats.new_service = other_results_stats.new_service ? other_results_stats.new_service.result_count : 0;
            other_results_stats.urgent_device_ts = other_results_stats.urgent_device_ts ? other_results_stats.urgent_device_ts.result_count : 0;
            other_results_stats.other = other_results_stats.other ? other_results_stats.other.result_count : 0;

            other_results_stats.abt_appt_total = other_results_stats.accessory_purchase + other_results_stats.device_upgrade + other_results_stats.new_service + other_results_stats.urgent_device_ts + other_results_stats.other;
            other_results_stats.accessory_purchase_pct = other_results_stats.accessory_purchase / other_results_stats.abt_appt_total;
            other_results_stats.device_upgrade_pct = other_results_stats.device_upgrade / other_results_stats.abt_appt_total;
            other_results_stats.new_service_pct = other_results_stats.new_service / other_results_stats.abt_appt_total;
            other_results_stats.urgent_device_ts_pct = other_results_stats.urgent_device_ts / other_results_stats.abt_appt_total;
            other_results_stats.other_ts_pct = other_results_stats.other / other_results_stats.abt_appt_total;

            if (other_results_stats.abt_appt_total == 0) {
                other_results_stats.accessory_purchase_pct = other_results_stats.device_upgrade_pct = other_results_stats.new_service_pct = other_results_stats.urgent_device_ts_pct = 0;
                other_results_stats.empty_segment = this.segment_gray;
            }
        }
        if (bTodayOnly) {
            if (this.isAssociatesWorkingToday) {
                // associates_working_today
                other_results_stats.associates_working = other_results.find(r => r.result_name == 'associates_working_today' && r.result_label == 'associates_working').result_count;
                other_results_stats.associates_not_working = other_results.find(r => r.result_name == 'associates_working_today' && r.result_label == 'associates_not_working').result_count;
                other_results_stats.associates_total = other_results.find(r => r.result_name == 'associates_working_today' && r.result_label == 'associates_total').result_count;
                other_results_stats.associates_working_pct = other_results_stats.associates_working / other_results_stats.associates_total;
                other_results_stats.associates_not_working_pct = other_results_stats.associates_not_working / other_results_stats.associates_total;
                if (other_results_stats.associates_total == 0) {
                    other_results_stats.associates_working = other_results_stats.associates_not_working = 0;
                    other_results_stats.empty_segment = this.segment_gray;
                }
            }
        } else {
            if (this.isActiveLeadContacted) {
                // active_leads_contacted
                other_results_stats.leads_contacted = other_results.find(r => r.result_name == 'active_leads_contacted' && r.result_label == 'leads_contacted').result_count;
                other_results_stats.leads_not_contacted = other_results.find(r => r.result_name == 'active_leads_contacted' && r.result_label == 'leads_not_contacted').result_count;
                other_results_stats.leads_total = other_results.find(r => r.result_name == 'active_leads_contacted' && r.result_label == 'leads_total').result_count;
                other_results_stats.leads_contacted_pct = other_results_stats.leads_contacted / other_results_stats.leads_total;
                other_results_stats.leads_not_contacted_pct = other_results_stats.leads_not_contacted / other_results_stats.leads_total;
                if (other_results_stats.leads_total == 0) {
                    other_results_stats.leads_contacted_pct = other_results_stats.leads_not_contacted_pct = 0;
                    other_results_stats.empty_segment = this.segment_gray;
                }
            }
        }        
        return other_results_stats;
    }
    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++//


    // updateMonthlySales(bReloadOtherResults:boolean, bReloadActionPlan:boolean) {
    //     // consultant view (scope_type is null)
    //     if (this.scope_type == null && bReloadActionPlan && !this.is_current_month) {
    //         this.action_plan = this.uscStoreService.getPreviousUserActionPlanByMonth(this.current_user, this.scope_month);
    //         this.analyzeActionPlan();
    //         // this.uscStoreService.getPreviousActionPlans().subscribe(items => {
    //         //     this.action_plan = items.find(ap => ap.cs_subject == this.scope_month && ap.ur_user_ID == this.current_user.ID.toString());
    //         //     this.analyzeActionPlan();
    //         // })
    //     } else if (this.scope_type != 'user') {
    //         if (!this.is_current_month) {
    //             this.scope_achievement = this.uscStoreService.getConsultantSummaryAchievementFromPreviousActionPlans(this.scope_month, this.scope_type, this.scope_value, this.sales_mode);
    //             // HACK: legacy code to make sure quota is correct
    //             if (this.scope_achievement.quota_accessory_revenue == null && this.scope_achievement.quota_accessories_revenue != null) this.scope_achievement.quota_accessory_revenue = this.scope_achievement.quota_accessories_revenue;
    //             if (this.scope_achievement.quota_accessory_revenue != null && this.scope_achievement.quota_accessories_revenue == null) this.scope_achievement.quota_accessories_revenue = this.scope_achievement.quota_accessory_revenue;

    //             if (this.scope_achievement.accessories_revenue != null && (this.scope_achievement.accessory_revenue == null || isNaN(this.scope_achievement.accessory_revenue))) this.scope_achievement.accessory_revenue = this.scope_achievement.accessories_revenue;
    //             if (this.scope_achievement.accessory_revenue != null && (this.scope_achievement.accessories_revenue == null || isNaN(this.scope_achievement.accessories_revenue))) this.scope_achievement.accessories_revenue = this.scope_achievement.accessory_revenue;
    //         }
    //         else if (this.uscStoreService.isLeader() && this.scope_type && this.scope_value) {
    //             if (this.sales_mode == "quota") {
    //                 if (this.isMonthlySales) this.scope_achievement = this.uscStoreService.getStoreSalesQuotaSummaryAchievementByScope(this.scope_type, this.scope_value);
    //                 else if (this.isDailySales) this.scope_achievement = this.uscStoreService.getTodaysStoreSalesQuotaAchievementByScope(this.scope_type, this.scope_value);
    //             } else if (this.sales_mode == "goal") {
    //                 if (this.isMonthlySales) this.scope_achievement = this.uscStoreService.getStoreSalesGoalAchievementByScope(this.scope_type, this.scope_value);
    //                 else if (this.isDailySales) this.scope_achievement = this.uscStoreService.getTodaysStoreSalesGoalAchievementByScope(this.scope_type, this.scope_value);
    //             }
    //         }
    //     }

    //     if (this.isActivePlanApproved || this.isAppointmentsAssigned || this.isAppointmentsByType || this.isActiveLeadContacted || this.isAssociatesWorkingToday) {
    //         this.getCalculatedOtherResults(this.isDailySales, this.scope_type, this.scope_value, this.scope_month, bReloadOtherResults);
    //     }
    // }

    // getPlacementLabel():string {
    //     if (this.isCustomAchievement) return "first last";
    //     var label = this.placement.achievement.AssociateName != null ? this.placement.achievement.AssociateName : (this.placement.achievement.store);
    //     switch (this.result_type) {
    //         case 'region': 
    //         case 'territory': 
    //         case 'area': 
    //         case 'store': 
    //             label = this.placement.achievement[this.result_type]; break;
    //         default: 
    //             label = this.placement.achievement.AssociateName; 
    //             break;
    //     }
    //     return label;
    // }
    
    // getStoreInfo() {
    //     if (this.isCustomAchievement) return "store info";
    //     var info = "";
    //     if (this.isWeightedScorecard && this.placement && this.result_type == 'associate') {
    //         info = this.placement.achievement.store;
    //     }
    //     return info;
    // }

    // getPlacementPercentage():number {
    //     return (this.placement) ? this.placement.achievement.total_weighted_pct : 0;
    // }

    // getDtdPercentage(): number {
    //     var quota_or_goal = this.isSalesVsGoal ? this.getP2WDailyGoal() : this.getDailyQuota();
    //     var pct = this.getDtd() / quota_or_goal;
    //     // for visual accuracy, never say 100% unless it is 100% 
    //     return (pct > 0.99 && pct < 1) ? 0.99 : pct;
    // }

    // showIcon() {
    //     return this.isDailySales;
    // }


    // getFormattedMtd() {
    //     var mtd = this.getMtd();
    //     return (this.mtd.indexOf("revenue") >= 0) ? this.translatorService.toCurrency(mtd) : mtd.toFixed(0);
    // }

    // getMtd():number {
    //     if (this.scope_achievement) {
    //         let mtd:number = this.scope_achievement[this.mtd] ? this.scope_achievement[this.mtd] : 0;
    //         return mtd;
    //     } else if (this.action_plan) {
    //         let mtd:number = this.action_plan[this.mtd] ? this.action_plan[this.mtd] : 0;
    //         return mtd;
    //     }
    //     return 0;
    // }

    // getQuota():number {
    //     var quota = 0;
    //     var quota_field = this.quota;
    //     if (this.scope_achievement) {
    //         // if (!this.uscStoreService.isUSCellTelesales()) {
    //         //     switch (this.scope_type) {
    //         //         case "area": quota_field = this.area_quota; break;
    //         //         case "territory": quota_field = this.territory_quota; break;
    //         //         case "region": quota_field = this.region_quota; break;
    //         //     }
    //         // }
    //         return (this.scope_achievement[quota_field]) ? this.scope_achievement[quota_field] : 0;
    //     } else if (this.action_plan) {
    //         try {
    //         var user_quota = JSON.parse(this.action_plan[quota_field]);
    //         if (user_quota && user_quota[this.action_plan.cs_subject]) quota = user_quota[this.action_plan.cs_subject];
    //         } catch (e) {
    //             console.log(e);
    //         }
    //     }
    //     return quota;
    // }



    // getP2WGoal():number {
    //     var goal = 0;
    //     if (this.scope_achievement) {
    //         goal = (this.scope_achievement[this.p2w_goal]) ? this.scope_achievement[this.p2w_goal] : 0;
    //     } else if (this.action_plan) {
    //         goal = (this.action_plan[this.p2w_goal]) ? this.action_plan[this.p2w_goal] : 0;
    //     }
    // return goal;
    // }    

    // getFormattedDtd() {
    //     var dtd = this.getDtd();
    //     return (this.dtd.indexOf("revenue") >= 0) ? this.translatorService.toCurrency(dtd) : dtd.toFixed(0);
    // }

    // getDtd():number {
    //     if (this.scope_achievement) {
    //         let dtd:number = this.scope_achievement[this.dtd] ? this.scope_achievement[this.dtd] : 0;
    //         return dtd;
    //     } else if (this.action_plan && this.daily_goal && this.dtd) {
    //         let dtd:number = this.daily_goal[this.dtd] ? this.daily_goal[this.dtd] : 0;
    //         return dtd;
    //     }
    //     return 0;
    // }

    // getFormattedDailyQuota() {
    //     var daily_quota = this.getDailyQuota();
    //     return (this.dtd.indexOf("revenue") >= 0) ? this.translatorService.toCurrency(daily_quota) : daily_quota.toFixed(0);
    // }

    // // Scorecord  View Only (Leader Only, Sales vs Quota) 
    // getDailyQuota():number {
    //     if (this.isSalesVsQuota) {
    //         if (this.scope_achievement || this.action_plan) {
    //             var quota = this.getQuota();
    //             var daily_quota = quota / this.days_in_month;
    //             return daily_quota;
    //         }
    //     } else if (this.action_plan) {
    //         var p2w_daily_quota = this.action_plan[this.p2w_goal] / this.action_plan.cs_days_scheduled;
    //         return p2w_daily_quota;
    //     }
    //     return 0;
    // }

    // getFormattecDailyGoal() {
    //     var daily_goal = this.getP2WDailyGoal();
    //     return (this.dtd.indexOf("revenue") >= 0) ? this.translatorService.toCurrency(daily_goal) : daily_goal.toFixed(0);
    // }

    // getP2WDailyGoal():number {
    //     var daily_goal = 0;
    //     if (this.isSalesVsGoal) {
    //         return (this.daily_goal) ? parseInt(this.daily_goal[this.todays_goal]) : this.getP2WGoal() / this.days_in_month;
    //     } else if (this.scope_achievement) {
    //         daily_goal = this.scope_achievement[this.todays_goal];
    //     }
    //     return daily_goal;
    // }

    // analyzeActionPlan() {
    //     if (this.action_plan) {
    //         var sales_vs_quotas = JSON.parse(this.action_plan.cs_sales_vs_quotas);
    //         this.action_plan.mtd_postpaid_handset_volume = sales_vs_quotas.postpaid_handset_volume;
    //         this.action_plan.mtd_other_volume = sales_vs_quotas.other_volume;
    //         this.action_plan.mtd_bir = sales_vs_quotas.bir;
    //         this.action_plan.mtd_accessories_revenue = sales_vs_quotas.accessory_revenue;
    //         this.action_plan.mtd_other_revenue = sales_vs_quotas.other_revenue;
    //         this.action_plan.mtd_upgrades = sales_vs_quotas.upgrades;
    //         this.action_plan.mtd_high_msrp_accessories = sales_vs_quotas.high_msrp_accessories;
    //         this.action_plan.mtd_device_trade_ins = sales_vs_quotas.device_trade_ins;
    //     }
    // }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-metrics-bar/usc-metrics-bar.component.ts